import { ArrowRight, ShieldCheck } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden pt-[180px] pb-[180px] bg-nuuma-primary text-white"
    >
      {/* Brand background image */}
      <div
        aria-hidden
        className="absolute inset-0 bg-center bg-cover opacity-55"
        style={{ backgroundImage: "url('/assets/nuuma-hero-bg.webp')" }}
      />
      {/* Dark overlay for legibility */}
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(41,33,104,0.82) 0%, rgba(41,33,104,0.78) 45%, rgba(41,33,104,0.92) 100%)",
        }}
      />

      {/* Decorative gradient blobs */}
      <div
        aria-hidden
        className="absolute -top-24 -right-24 h-[420px] w-[420px] rounded-full opacity-30 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, rgba(239,96,121,0.7) 0%, transparent 70%)",
        }}
      />
      <div
        aria-hidden
        className="absolute -bottom-32 -left-32 h-[520px] w-[520px] rounded-full opacity-25 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, rgba(238,159,91,0.6) 0%, transparent 70%)",
        }}
      />

      <div className="nuuma-container relative z-10">
        <div className="max-w-3xl lg:max-w-4xl mx-auto text-center animate-fade-up">
          <span
            data-testid="hero-eyebrow"
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/15 text-[0.78rem] tracking-wider uppercase text-white/90 mb-6"
          >
            <ShieldCheck className="h-3.5 w-3.5 text-nuuma-accent1" />
            Laboratorium genetyczne · Alicante, Hiszpania
          </span>

          <h1
            data-testid="hero-title"
            className="font-display font-extrabold text-white leading-[1.1] text-4xl sm:text-5xl lg:text-6xl tracking-tight"
          >
            Twoja droga do świadomego{" "}
            <span className="text-nuuma-accent1">zdrowia</span> i{" "}
            <span className="text-nuuma-secondary">rodzicielstwa</span> z Nuuma
            Genetics
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-6 text-base sm:text-lg text-white/80 max-w-2xl mx-auto leading-relaxed"
          >
            Zaawansowane badania genetyczne wspierające diagnostykę medyczną,
            płodność i zdrowie.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 items-center justify-center">
            <a
              href="#kontakt"
              data-testid="hero-cta-primary"
              className="btn-pill btn-primary-nuuma"
            >
              Znajdź badanie dla siebie
              <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href="#segmenty"
              data-testid="hero-cta-secondary"
              className="btn-pill bg-white/10 text-white border border-white/20 hover:bg-white/20"
            >
              Poznaj ofertę
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-[0.82rem] text-white/65">
            <span>10+ lat doświadczenia</span>
            <span className="hidden sm:inline text-white/25">•</span>
            <span>Skuteczność IVF do 75%</span>
            <span className="hidden sm:inline text-white/25">•</span>
            <span>Próbki pobierane w Polsce</span>
          </div>
        </div>
      </div>
    </section>
  );
}
